"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function ThumbUp20Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_14195_23198)" },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7079 7.75H13.3809H13.3825H13.7055C15.1733 7.75 16.2481 9.13263 15.886 10.555L15.0753 13.74C14.7369 15.0695 13.5398 16 12.168 16H8.5H7H5.5H4V14.5V10V8.5H5.5H7L8.24359 4.76924C8.39671 4.30986 8.82662 4 9.31085 4H9.34941C10.7103 4 11.8105 5.02968 11.9579 6.32427C11.9787 6.50702 11.9805 6.69504 11.9614 6.8862L11.9579 6.92126L11.8832 7.66754C11.8788 7.71169 11.9135 7.75 11.9579 7.75H12.7079ZM8.5 8.74342V10V14.5H12.168C12.8539 14.5 13.4524 14.0347 13.6216 13.37L14.4323 10.185C14.553 9.71088 14.1948 9.25 13.7055 9.25H11.9579C11.0261 9.25 10.298 8.44546 10.3907 7.51828L10.4688 6.73694C10.5274 6.15123 10.1274 5.63403 9.57371 5.52229L8.5 8.74342ZM7 10H5.5V14.5H7V10Z", fill: "#868A98" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_14195_23198" },
                react_1.default.createElement("rect", { width: 12, height: 12, fill: "white", transform: "translate(4 4)" }))));
}
function ThumbUp20(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(ThumbUp20Svg, Object.assign({}, svgProps)));
}
exports.default = ThumbUp20;
//# sourceMappingURL=ThumbUp20.js.map